module.exports = __webpack_public_path__ + "img/Orange.8ef4f409.png";